export const SubmitData = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M10.5 7H15.1667C15.8083 7 16.3333 6.475 16.3333 5.83333C16.3333 5.19167 15.8083 4.66667 15.1667 4.66667H10.5C9.85833 4.66667 9.33333 5.19167 9.33333 5.83333C9.33333 6.475 9.85833 7 10.5 7ZM10.5 11.6667H15.1667C15.8083 11.6667 16.3333 11.1417 16.3333 10.5C16.3333 9.85833 15.8083 9.33333 15.1667 9.33333H10.5C9.85833 9.33333 9.33333 9.85833 9.33333 10.5C9.33333 11.1417 9.85833 11.6667 10.5 11.6667ZM10.5 16.3333H15.1667C15.8083 16.3333 16.3333 15.8083 16.3333 15.1667C16.3333 14.525 15.8083 14 15.1667 14H10.5C9.85833 14 9.33333 14.525 9.33333 15.1667C9.33333 15.8083 9.85833 16.3333 10.5 16.3333ZM4.66667 4.66667H7V7H4.66667V4.66667ZM4.66667 9.33333H7V11.6667H4.66667V9.33333ZM4.66667 14H7V16.3333H4.66667V14ZM19.8333 0H1.16667C0.525 0 0 0.525 0 1.16667V19.8333C0 20.475 0.525 21 1.16667 21H19.8333C20.475 21 21 20.475 21 19.8333V1.16667C21 0.525 20.475 0 19.8333 0ZM18.6667 18.6667H2.33333V2.33333H18.6667V18.6667Z"
        fill="#C4C4CD"
      />
    </svg>
  );
};
